var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 7.07143C15.3303 7.07143 14.9935 9.5 14.2678 9.5C13.5421 9.5 13.9642 7.07143 13.2053 7.07143C12.2946 7.07143 11.2321 10.7143 8.8035 10.7143C7.89278 10.7143 7.89278 8.94503 7.89278 7.22321C7.89278 5.50139 8.49992 4.64286 9.25885 4.64286C10.0178 4.64286 10.3214 5.25949 10.3214 5.85714C10.3214 8.28571 6.07135 10.7143 3.03564 10.7143C1.58893 10.7143 0.607069 7.71177 0.607069 5.85714C0.607069 2.82143 1.82135 1 3.64278 1C5.00885 1 5.46421 2.45619 5.46421 3.58036C5.46421 9.19643 0.303497 12.0804 0.303497 12.0804M0 14.3572H17",
    stroke: "#627790",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/sign-icon.0d89e86a80ff5c874ff4adaccbce2cee.svg";
export { ForwardRef as ReactComponent };